<template>
  <div>
    <v-overlay :value="dataReady">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
            <p></p>
          </v-col>

          <v-col cols="12">
            <v-card-title class="lighten-5">
              ขอเอกสาร
              <v-icon color="#871B12">mdi-comment-alert </v-icon>
            </v-card-title>

            <v-container fluid>
              <v-row align="center">
                <v-col cols="4">
                  <v-subheader> เอกสาร </v-subheader>
                </v-col>

                <v-col cols="8">
                  <v-select
                    v-model="formAdd.requestRocument"
                    :items="itemsDoc"
                    item-text="state"
                    item-value="abbr"
                    label="Select"
                    return-object
                    single-line
                  ></v-select>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="4">
                  <v-subheader> เหตุผลที่ขอเอกสาร </v-subheader>
                </v-col>

                <v-col cols="8">
                  <v-select
                    v-model="formAdd.requestDetail"
                    :items="dataItemDocument"
                    :rules="[v => !!v || 'กรุณา เลือก 1 รายการ']"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>

            <v-btn small color="success" @click="addData(formAdd)">
              บันทึกข้อมูล
            </v-btn>
          </v-col>
        </v-row>

        <v-card-title class="lighten-5"> ติดตามผล </v-card-title>
        <v-card elevation="10" class="ma-2 pa-2">
          <v-card-actions class="ma-0 pa-0">
            <v-btn
              v-if="dataItem.requestStatus == 'waiting'"
              color="orange"
              text
            >
              รออนุมัติ
            </v-btn>

            <v-btn
              v-if="dataItem.requestStatus == 'approve'"
              color="green"
              text
            >
              อนุมัติ
            </v-btn>

            <v-btn v-if="dataItem.requestStatus == 'cancle'" color="red" text>
              รายการถูกยกเลิก
            </v-btn>
          </v-card-actions>
          <v-subheader>โปรด รอเอกสาร จากฝ่ายบุคคล 7 - 10 วัน </v-subheader>
          {{ dataItem.requestRocument }}
        </v-card>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  components: {},
  name: 'Info',
  data () {
    return {
      profile: [],
      formAdd: [],
      dataItemDocument: [],
      dataItem: [],
      itemsDoc: ['หนังสือรับรองเงินเดือน'],
      itemsRemark: ['ทำธุรกรรมกับธนาคาร', 'ขอวีซ่า', 'ศึกษา', 'ค้ำประกัน'],
      imageHeadHRM: '',
      imageUrlBack: '',
      dataReady: false
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.dataReady = true
    this.profile = JSON.parse(localStorage.getItem('liff_info'))

    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    await this.getData()
    await this.getDataDocument()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/HomeSpecialRequest')
    },
    async getData () {
      this.dataReady = false
      this.dataItem = []
      const response = await axios.get(
        this.DNS_IP + '/doc_request/get?empCode=' + this.profile.empCode,
        {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        }
      )
      if (response.data) {
        this.dataItem = response.data[0]
        console.log('this.dataItem', this.dataItem)
      }
    },
    async getDataDocument () {
      this.dataItemDocument = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_document/get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          console.log('response', response.data)
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.masDocumentName
              s.text = d.masDocumentName
              this.dataItemDocument.push(s)
            }
          } else {
            this.dataItemDocument = []
          }
        })
    },
    addData (dt) {
      this.dataReady = true
      let ds = {
        empCode: this.profile.empCode,
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName,
        requestRocument: dt.requestRocument,
        requestStatus: 'waiting',
        requestDetail: dt.requestDetail
      }
      this.addDataSubmit(ds)
    },
    async addDataSubmit (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/doc_request/add",
          ds
        )
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'บันทึกข้อมูล เรียบร้อย', 'success')
          this.dataReady = false
          await this.getData()
          this.cleanData()
          await this.setUpBeforeSendLine(ds)
          await this.linenotify(ds)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async linenotify (dt) {
      var massageNoti =
        'ขอเอกสาร' +
        '\nชื่อพนักงาน : ' +
        this.profile.empFull_NameTH +
        '\nแผนก : ' +
        this.profile.masDepartmentName +
        '\nสาขา : ' +
        this.profile.masBranchName +
        '\nบริษัท : ' +
        this.profile.masCompanyName +
        '\nเบอร์โทรศัพท์ติดต่อ : ' +
        this.profile.empTel +
        '\nเอกสารที่ขอ : ' +
        dt.requestRocument +
        '\nเพื่อใช้ : ' +
        dt.requestDetail
      let ds = {
        token: 'ykOxnleuJDAAnR6CwdI98b7PJYidormK5ZdvOApt54Q', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    },
    async setUpBeforeSendLine (item) {
      var payload = [
        {
          type: 'flex',
          altText: 'ขอหนังสือรับรองเงินเดือน',
          contents: {
            type: 'bubble',
            header: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'text',
                  text: 'แจ้งเตือนขอหนังสือรับรองเงินเดือน',
                  size: 'xs',
                  offsetStart: 'lg',
                  decoration: 'underline'
                }
              ],
              offsetBottom: 'xs',
              offsetTop: 'xs',
              cornerRadius: 'none',
              paddingAll: 'md'
            },
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'horizontal',
                  contents: [
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'image',
                          url: 'https://api.betaskthai.com/upload/static/upload/Welfare/2022_10/EMP20218193_2022_10_11_14_50_57.png',
                          aspectMode: 'fit',
                          size: 'full'
                        }
                      ],
                      cornerRadius: '100px',
                      width: '75px',
                      height: '75px',
                      paddingEnd: 'sm'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          contents: [
                            {
                              type: 'span',
                              text: 'หนังสือรับรองเงินเดือน',
                              weight: 'bold',
                              color: '#000000',
                              size: 'md'
                            },
                            {
                              type: 'span',
                              text: '     '
                            },
                            {
                              type: 'span',
                              text: 'รออนุมัติจากผู้จัดการแผนกทรัพยากรบุคคล',
                              weight: 'bold'
                            }
                          ],
                          size: 'sm',
                          wrap: true
                        },
                        {
                          type: 'box',
                          layout: 'baseline',
                          contents: [
                            {
                              type: 'icon',
                              url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'
                            },
                            {
                              type: 'icon',
                              url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'
                            },
                            {
                              type: 'icon',
                              url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'
                            },
                            {
                              type: 'icon',
                              url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'
                            },
                            {
                              type: 'icon',
                              url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'
                            }
                          ],
                          spacing: 'sm',
                          margin: 'md'
                        }
                      ]
                    }
                  ],
                  spacing: 'xl',
                  paddingAll: '20px'
                }
              ],
              paddingAll: '0px'
            }
          }
        }
      ]
      await this.sendLinePush(payload, this.profile.userLineuserId)
      this.dataReady = false
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(
        // eslint-disable-next-line quotes
        this.DNS_IP + "/line/push_message",
        dt,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
    },
    cleanData () {
      this.formAdd.requestRocument = null
      this.formAdd.requestDetail = null
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/RequestDoc.vue